import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';

function StepBanner({ ads, stepper, pageLoading, plan }) {
  const theme = useTheme();
  const [showAd, setShowAd] = React.useState(null);
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = ads?.length;

  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      const lastCloseTime = localStorage.getItem('adClosedTime');
      if (lastCloseTime) {
        const elapsedTime = Date.now() - parseInt(lastCloseTime, 10);
        if (elapsedTime < 24 * 60 * 60 * 1000) {
          setShowAd(false);
        } else {
          setShowAd(true);
        }
      } else {
        setShowAd(true);
      }

      if (maxSteps > 0) {
        setActiveStep(Math.floor(Math.random() * maxSteps));
      }
    }
  }, [ads, maxSteps]);

  React.useEffect(() => {
    if (!(stepper?.autoplay ?? true) || maxSteps <= 1) return;
    const id = setInterval(() => {
      setActiveStep(prev => (prev + 1) % maxSteps);
    }, stepper?.interval ?? 3777);
    return () => clearInterval(id);
  }, [maxSteps, stepper]);

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  const handleCloseAd = () => {
    setShowAd(false);
    if (typeof window !== 'undefined') {
      localStorage.setItem('adClosedTime', Date.now().toString());
    }
  };

  if (showAd === null) {
    return null;
  }

  return (
    <>
      {!pageLoading && showAd && ads[activeStep]?.active && ads[activeStep]?.text && ads[activeStep]?.text !== "" ? (
        <Toolbar
          sx={{
            zIndex: (theme) => theme.zIndex.drawer,
            minHeight: { md: '1rem', sm: '1rem', xs: '1rem' },
            p: '4px !important',
            m: '0 !important',
            backgroundImage: ads[activeStep]?.backgroundImage ? `url(${ads[activeStep]?.backgroundImage})` : "",
            backgroundColor: ads[activeStep]?.backgroundColor || "",
            backgroundRepeat: 'no-repeat',
            backgroundSize: '100% auto',
            justifyContent: 'center',
            alignItems: 'start',
            display: 'flex',
            boxShadow: ads[activeStep]?.boxShadow || 0,
          }}
        >
          <Box sx={{ flexGrow: 1 }}>
            {ads[activeStep] && (
              <Box component="div"
                sx={{
                  textAlign: ads[activeStep]?.textAlign ?? 'center',
                  verticalAlign: "middle",
                  width: '100%',
                  pt: .2,
                  px: .4,
                  color: ads[activeStep]?.textColor || "",
                  '& h1, h2, h3, h4, h5, h6': {
                    fontSize: '1rem',
                    m: 0,
                    p: 0,
                    color: 'inherit',
                    textTransform: 'uppercase',
                    backdropFilter: ads[activeStep]?.backdropFilter ?? 'blur(2px)',
                  },
                  '& p, a': {
                    fontSize: '.875rem',
                    m: 0,
                    p: 0,
                    color: 'inherit',
                    textTransform: 'capitalize',
                    backdropFilter: ads[activeStep]?.backdropFilter ?? 'blur(2px)',
                  },
                }}
                dangerouslySetInnerHTML={{
                  __html: ads[activeStep]?.href ? `<a href="${ads[activeStep]?.href}">${ads[activeStep]?.text}</a>` : ads[activeStep]?.text || "",
                }}
              />
            )}
          </Box>
          <IconButton
            size="small"
            sx={{ color: '#0a196287', '&:hover': { color: 'primary.main' } }}
            onClick={handleCloseAd}
          >
            <CancelRoundedIcon sx={{ fontSize: "1rem", color: 'inherit' }} />
          </IconButton>
        </Toolbar>
      ) : null}
    </>
  );
}

export default StepBanner;
